import React, { Component } from 'react'
import Dropdown from 'react-bootstrap/Dropdown';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </div>
));

export default class NavBarItem extends Component {

    render() {
        return (
            <div className="app-navbar-button">
                <Dropdown>
                    <Dropdown.Toggle as={CustomToggle}>
                        {this.props.children}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="navbar-dropdown-menu">
                        {this.props.options.map(element => <Dropdown.Item className="navbar-dropdown-menu-item" onClick={element.onClick}>{element.text}</Dropdown.Item>)}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        )
    }
}